module.exports = __webpack_public_path__ + "static/media/IMG_0287.897e3e96.jpg";